<template>
  <div id="domain-create" class="row">
    <form id="create-domain-form" class="small-12 medium-5 columns" @submit.prevent="submitForm">
      <label>
        {{ 'Name'|t }}
        <input type="text" ref="name" v-model="name" required="required" autofocus />
      </label>

      <label>
        {{ 'IP addresses'|t }}
        <textarea v-model="ips" rows="5"></textarea>
      </label>

      <input type="submit" name="submit" :value="'Submit'|t" class="medium expanded success button" />
    </form>
  </div>
</template>

<script>
  import api from '@/api';
  import router from '@/routes';

  export default {
    name: 'CreateForm',
    data() {
      return {
        name: "",
        ips: [],
      }
    },
    methods: {
      submitForm() {
        let request = {
          name: this.name,
          ips: []
        };

        if (this.ips.length > 0) {
          let ips = this.ips.split("\n");
          ips.forEach(function (value) {
            if (value !== "") {
              request.ips.push(value);
            }
          });
        }

        api.createHost(
          request,
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "Host %s has been created.",
              args: [data.name]
            }, {root: true});
            router.push({name: 'host.collection'});
          }
        );
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/host/CreateForm.vue